export function getMonthT1UTC2(monthIndex: number, year: number): Date {
	const timestampMs = Date.UTC(year, monthIndex, 1, 0, 0, 0, 0)
	return new Date(timestampMs)
}
